const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaVideoTrilha: [
		{ id: 'pre_incubacao', valor: 'Pré-incubação' },
		{ id: 'pre_incubacao_ideacao', valor: 'Pré-incubação / Ideação' },
		{ id: 'pre_incubacao_prototipo', valor: 'Pré-incubação / Protótipo' },
		{ id: 'pre_incubacao_validacao', valor: 'Pré-incubação / Validação' },
		{ id: 'pre_incubacao_pitch', valor: 'Pré-incubação / Pitch' }
	]
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'MENTOR_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'MENTOR_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'MENTOR_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        default:
            return state;
    }
}
